const fetchPermissions = () => ({
  artwork: 0,
  pizzas: 1,
  pricePanel: 1,
  ratingSystem: 1,
  ticketSystem: 1,
});

export default fetchPermissions();
